
const DEFAULT_API_URL = process.env.REACT_APP_API_URL;
const STORAGE_KEY = 'solmaz_api_url_override';

function readStoredApiUrl() {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch (e) {
    return '';
  }
}

function normalizeUrl(url) {
  if (!url) return '';
  try {
    const u = new URL(url);
    return u.toString().replace(/\/$/, '');
  } catch (e) {
    return '';
  }
}

let apiUrlCache = normalizeUrl(readStoredApiUrl()) || normalizeUrl(DEFAULT_API_URL);

export const API_URL = apiUrlCache;

export function setRuntimeApiUrl(newUrl) {
  const normalized = normalizeUrl(newUrl);
  if (!normalized) return false;
  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch (e) {
    void e; // ignore storage errors (private mode or blocked)
  }
  apiUrlCache = normalized;
  window.location.reload();
  return true;
}

export function getRuntimeApiUrl() {
  return apiUrlCache;
}

export function resetRuntimeApiUrl() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    void e; // ignore storage errors (private mode or blocked)
  }
  apiUrlCache = normalizeUrl(DEFAULT_API_URL);
  window.location.reload();
}
export const GEO_API_URL = 'https://geocodeapi.solmaz.com/api/v1';
export const ReCAPTCHA_SITE_KEY = '6Lc4LFUlAAAAAIPuIYWfOc_TO75D2pCGYG-Mv_t0';
